import { StorageFilePath } from "@snubes/snubes-types";
import { ref } from "firebase/storage";
import { storage } from "../consts/FIREBASE";

export function getStorageRef(path: StorageFilePath) {
  return ref(storage, path);
}
